module.exports = __webpack_public_path__ + "static/media/usg-usdt-button.d3cec9d1.png";